import { Router, ActivatedRoute, Params } from '@angular/router';
import { Component, OnInit, Input } from '@angular/core';
import {
  CustomProffixService, HelpersService, UserSessionService, StundenAntrag,
  LocalStorageService, UserDefaults
} from '../../services';

import {
  Login,
  Mitarbeiter,
  MitarbeiterService,
  StundenService,
  Stunden,
  StundenartService,
  Stundenart
} from '@proffix/restapi-angular-library';

@Component({
  selector: 'app-requests',
  templateUrl: './requests.component.html',
  styleUrls: ['./requests.component.css']
})
export class RequestsComponent implements OnInit {
  proffixLogin: Login = null;

  private _page = 1;
  itemsPerPage = 10;
  isLoaded = false;
  isManager = false;
  isTeamleiter = false;

  filterMitarbeiterNr = 0;
  filterStatusCode = '0';
  filterStundenart = '-';
  filterPeriode = '-';

  userDefaults: UserDefaults;

  stundenAntraegeList: StundenAntrag[];
  listOfMitarbeiter: Mitarbeiter[];
  listOfStundenarten: Stundenart[];
  listOfPerioden: string[] = [];

  constructor(
    private _customProffixService: CustomProffixService,
    private _helpersService: HelpersService,
    private _userSessionService: UserSessionService,
    private _localStorageService: LocalStorageService,
    private _mitarbeiterService: MitarbeiterService,
    private _stundenService: StundenService,
    private _stundenartService: StundenartService) {
  }

  ngOnInit() {
    this._userSessionService.getProffixLogin().subscribe(data => {
      this.proffixLogin = data;
      this.isManager = this._userSessionService.isManager();
      this.isTeamleiter = this._userSessionService.isTeamleiter();
      this.userDefaults = this._localStorageService.loadUserDefaults(data.Benutzer);

      if (data) {
        if (this.isManager === false && this.isTeamleiter == false) {
          this.filterMitarbeiterNr = data.Mitarbeiter.MitarbeiterNr;
        } else {
          this.filterMitarbeiterNr = this.userDefaults.FilterMitarbeiterNr ? this.userDefaults.FilterMitarbeiterNr : 0;
        }

        if (this.userDefaults) {
          this.filterStatusCode = this.userDefaults.FilterStatusCode ? this.userDefaults.FilterStatusCode : '0';
          this.filterStundenart = this.userDefaults.FilterStundenart ? this.userDefaults.FilterStundenart : '-';
          this.filterPeriode = this.userDefaults.FilterPeriode ? this.userDefaults.FilterPeriode : '-';
          this.itemsPerPage = this.userDefaults.ItemsPerPage ? this.userDefaults.ItemsPerPage : 10;
        }

        // load the list of all Mitarbeiter that the current user is allowed to see
        this._customProffixService
          .getListOfAssignedMitarbeiter(this.proffixLogin.Mitarbeiter.MitarbeiterNr, this.isManager)
          .subscribe(result => {
            this.listOfMitarbeiter = this.SortMitarbeiterByName(result);

            // load the data
            this.loadStundenAntraege();
            this.loadStundenarten();
          });

        this.listOfPerioden = this._helpersService.getListOfPeriodes(new Date(), 3, 12);
      }
    });
  }

  get page(): number {
    // transform value for display
    return this._page;
  }

  @Input()
  set page(value: number) {
    if (value > 0) {
      this._page = value;
      this.loadStundenAntraege();
    }
  }

  public changeItemsPerPage() {
    this.search();
  }

  public pageBack() {
    if (this.page > 1) {
      this.page = this.page - 1;
    }
  }

  public pageNext() {
    this.page = this.page + 1;
  }

  public search() {
    this._page = 1;
    this.loadStundenAntraege();

    // store the search form values
    this.userDefaults.FilterMitarbeiterNr = this.filterMitarbeiterNr;
    this.userDefaults.FilterStatusCode = this.filterStatusCode;
    this.userDefaults.FilterStundenart = this.filterStundenart;
    this.userDefaults.FilterPeriode = this.filterPeriode;
    this.userDefaults.ItemsPerPage = this.itemsPerPage;

    this._localStorageService.saveUserDefaults(this.proffixLogin.Benutzer, this.userDefaults);
  }

  private loadStundenAntraege() {
    this.isLoaded = false;

    this._userSessionService.handleRequest(() => {
      return this._customProffixService.getStundenAntrag(
        {
          sort: '-Datum,-StartZeit',
          limit: this.itemsPerPage,
          offset: this.getOffset(),
          filter: this.getFilterString(),
        });
    }).subscribe((result) => {
      this.stundenAntraegeList = result;

      this.stundenAntraegeList.forEach((antw, index, list) => {
        // cut the time values into a string with the pattern HOUR:MINUTE
        if (antw.StartZeit !== null && antw.StartZeit.length > 5) {
          list[index].StartZeit = antw.StartZeit.substring(0, 5);
        }
        if (antw.EndZeit !== null && antw.EndZeit.length > 5) {
          list[index].EndZeit = antw.EndZeit.substring(0, 5);
        }

        // load the original "Stunden" record
        if (antw.StundenNr !== null && antw.StundenNr !== 0
          && !(antw.AntragsArt === 20 && antw.StatusCode === 10) // exclude accepted delete request
        ) {
          this._stundenService.get(antw.StundenNr)
            .subscribe(stunde => {
              list[index].OriginalStunden = stunde;
            });
        }
      });

      this.isLoaded = true;
    });
  }

  private SortMitarbeiterByName(listOfMitarbeiter: Mitarbeiter[]): Mitarbeiter[] {
    listOfMitarbeiter.sort((x, y) => {
      if (x.Adresse.Name < y.Adresse.Name) {
        return -1;
      } else if (x.Adresse.Name > y.Adresse.Name) {
        return 1;
      } else {
        return 0;
      }
    });

    return listOfMitarbeiter;
  }

  private getFilterString(): string {
    let filter = '';

    if (this.filterMitarbeiterNr !== 0) {
      filter = filter + 'MitNrPRO==' + this.filterMitarbeiterNr + ',';
    } else {
      // filter for all employees the current role is assigned to see
      filter = filter + '(';
      this.listOfMitarbeiter.forEach(m => {
        filter = filter + 'MitNrPRO==' + m.MitarbeiterNr + '|';
      });
      filter = filter.slice(0, -1);
      filter = filter + '),';
    }

    if (this.filterStatusCode !== '0') {
      filter = filter + 'StatusCode==' + this.filterStatusCode + ',';
    }

    if (this.filterStundenart !== '-') {
      filter = filter + 'StundenartZEI=="' + this.filterStundenart + '",';
    }

    if (this.filterPeriode && this.filterPeriode.length === 6) {
      filter = filter + this._helpersService.getPeriodeFilterString('Datum', this.filterPeriode);
    }

    return filter.slice(0, -1);
  }

  private getOffset() {
    return (this.page - 1) * this.itemsPerPage;
  }

  private loadStundenarten() {
    this._stundenartService.getAll({}).subscribe(result => {
      result.sort((x, y) => {
        if (x.Bezeichnung < y.Bezeichnung) {
          return -1;
        } else if (x.Bezeichnung > y.Bezeichnung) {
          return 1;
        } else {
          return 0;
        }
      });
      this.listOfStundenarten = result;
    });
  }

  public getMitarbeiterName(mitNrPRO: number): string {
    if (this.listOfMitarbeiter !== undefined) {
      const ma = this.listOfMitarbeiter.find(x => x.MitarbeiterNr === mitNrPRO);

      if (ma !== undefined) {
        return ma.Adresse.Name + ' ' + ma.Adresse.Vorname;
      }
    }

    return '';
  }

  public getStundenartBezeichnung(stundenartNr: string): string {
    if (this.listOfStundenarten !== undefined) {
      const sa = this.listOfStundenarten.find(x => x.StundenartNr === stundenartNr);

      if (sa !== undefined) {
        return sa.Bezeichnung;
      }
    }

    return '';
  }

  public filterVisibleMitarbeiter(ma: Mitarbeiter): boolean {
    return ma && ma.Zusatzfelder && ma.Zusatzfelder.Z_Zeitmanagement_Rolle && ma.Zusatzfelder.Z_Zeitmanagement_Rolle !== '';
  }

  public filterVerwendeteStundenarten(s: Stundenart): boolean {
    return s.Zusatzfelder.Z_In_Zeitmanagement_WebApp_verwenden === true;
  }

  public updateBemerkungManager(stundenAntrag: StundenAntrag) {
    this._userSessionService.handleRequest(() => {
      return this._customProffixService.putStundenAntrag(stundenAntrag);
    }).subscribe(() => { });
  }

  public acceptStundenantrag(stundenAntrag: StundenAntrag) {
    // set the code for "Accepted"
    stundenAntrag.StatusCode = 10;

    // prepare the request for the "StundenAntrag". Execute later...
    const stundenAntragUpdate = this._customProffixService.putStundenAntrag(stundenAntrag);

    if (stundenAntrag.AntragsArt === 10) {
      // It's a change request
      stundenAntrag.OriginalStunden.Stundenart = { StundenartNr: stundenAntrag.StundenartZEI };
      stundenAntrag.OriginalStunden.Datum = stundenAntrag.Datum;
      stundenAntrag.OriginalStunden.StartZeit = stundenAntrag.StartZeit;
      stundenAntrag.OriginalStunden.EndZeit = stundenAntrag.EndZeit;
      stundenAntrag.OriginalStunden.Pause = stundenAntrag.Pause;
      stundenAntrag.OriginalStunden.Stunden = stundenAntrag.Stunden;

      this._customProffixService.putStunden(stundenAntrag.OriginalStunden).subscribe(() => {
        // "Stunden"-record successfully updated: run the update of the "StundenAntrag"
        stundenAntragUpdate.subscribe();
      });
    } else if (stundenAntrag.AntragsArt === 20) {
      // It's a delete request

      this._customProffixService.deleteStunden(stundenAntrag.OriginalStunden).subscribe(() => {
        // "Stunden"-record successfully updated: run the update of the "StundenAntrag"
        stundenAntragUpdate.subscribe();
      });
    } else if (stundenAntrag.AntragsArt === 101 || stundenAntrag.AntragsArt === 102) {
      // It's a request for adding some hours (Stunden)
      const stunden: Stunden = {
        Mitarbeiter: { MitarbeiterNr: stundenAntrag.MitNrPRO },
        Stundenart: { StundenartNr: stundenAntrag.StundenartZEI },
        Datum: stundenAntrag.Datum,
        StartZeit: stundenAntrag.StartZeit,
        EndZeit: stundenAntrag.EndZeit,
        Stunden: stundenAntrag.Stunden,
        Pause: stundenAntrag.Pause,
        Bemerkungen: stundenAntrag.BemerkungMitarbeiter,
        Quelle: 'TimeManagement Web',
        QuelleStop: 'TimeManagement Web',
      };

      this._customProffixService.postStunden(stunden).subscribe(() => {
        // "Stunden"-record successfully created: run the update of the "StundenAntrag"
        stundenAntragUpdate.subscribe();
      });
    }

  }

  public changeStatusOfStundenantrag(stundenAntrag: StundenAntrag, newStatusCode: number) {
    // set the given code and save the Antrag
    stundenAntrag.StatusCode = newStatusCode;

    this._userSessionService.handleRequest(() => {
      return this._customProffixService.putStundenAntrag(stundenAntrag);
    }).subscribe(() => { });
  }

  public calculateStunden(stundenAntrag: StundenAntrag) {
    return this._helpersService.calculateTimeSpan(stundenAntrag.StartZeit, stundenAntrag.EndZeit) - stundenAntrag.Pause;
  }

  public fixAllMissingStunden() {
    this._customProffixService.getStundenAntrag({}).subscribe((listOfLoadedAntrage) => {
      this.fixNextMissingStunden(listOfLoadedAntrage);
    });
  }

  fixNextMissingStunden(listOfAntraege: StundenAntrag[]) {
    const next = listOfAntraege.shift();
    next.Stunden = this.calculateStunden(next);

    this._customProffixService.putStundenAntrag(next).subscribe(() => {
      if (listOfAntraege.length > 0) {
        this.fixNextMissingStunden(listOfAntraege);
      } else {
        alert('Fertig');
      }
    });
  }
}



// WEBPACK FOOTER //
// C:/.NET Projects/Angular Apps/TimeManagement/src/app/dialogs/requests/requests.component.ts